"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUploadLink = createUploadLink;

var _printer = require("graphql/language/printer");

var _uuid = require("uuid");

var _apolloLink = require("apollo-link");

var _extractFiles = require("extract-files");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* global FormData, fetch */
function transformVariables(variables = {}) {
  return Object.entries(variables).filter(([_, v]) => v !== undefined && typeof v !== 'function').reduce((acc, [k, v]) => _objectSpread(_objectSpread({}, acc), {}, {
    [k]: {
      type: 'value',
      value: v
    }
  }), {});
}

function createUploadLink({
  uri: linkUri,
  headers: linkHeaders
}) {
  return new _apolloLink.ApolloLink(({
    operationName,
    variables,
    query,
    getContext
  }) => new _apolloLink.Observable(observer => {
    const {
      files
    } = (0, _extractFiles.extractFiles)(variables);
    let stringifiedVariables = {};
    const {
      uri = linkUri,
      headers: contextHeaders,
      fetchOptions: contextFetchOptions = {}
    } = getContext();
    const fetchOptions = Object.assign({}, contextFetchOptions, {
      headers: Object.assign({}, contextFetchOptions.headers, linkHeaders, contextHeaders),
      method: 'POST',
      body: new FormData()
    });
    fetchOptions.body.append('operationName', operationName);
    fetchOptions.body.append('query', (0, _printer.print)(query));

    if (files.size) {
      const fileKeys = Array.from(files.values()).reduce((acc, items) => acc.concat(items), []).reduce((acc, path) => {
        const val = path.split('.')[0]; // f.path is a path to an array, like 'files.0'

        return acc.indexOf(val) > -1 ? acc : [...acc, val];
      }, []);
      let tempVars = transformVariables(variables);
      fileKeys.forEach(k => {
        const name = (0, _uuid.v4)();
        files.forEach((paths, file) => {
          if (paths.some(path => path.indexOf(k === 0))) {
            fetchOptions.body.append(name, file);
          }
        });
        tempVars = _objectSpread(_objectSpread({}, tempVars), {}, {
          [k]: {
            type: 'file-list',
            field: name
          }
        });
      });
      stringifiedVariables = JSON.stringify(tempVars, null, 2);
    } else {
      stringifiedVariables = JSON.stringify(transformVariables(variables), null, 2);
    }

    fetchOptions.body.append('variables', stringifiedVariables);
    fetch(uri, fetchOptions).then(response => {
      if (!response.ok) throw new Error(`${response.status} (${response.statusText})`);
      return response.json();
    }).then(result => {
      observer.next(result);
      observer.complete();
    }).catch(error => observer.error(error));
  }));
}